export default __webpack_public_path__ + "static/media/Chrono.72712fa3.svg";